exports.getMsid = function getMsid() {return elementorySupport.getJSON(generateWebMethodUrl("getMsid","backend/getMsid.jsw"), arguments, undefined, undefined)}